import { useMutation, useQueryClient } from '@tanstack/react-query';
import { createSubscription } from '../services/subscriptions.api';
import type { CreateSubscriptionDTO } from '../types';

export function useCreateSubscription() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (data: CreateSubscriptionDTO) => createSubscription(data),
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: ['subscriptions', 'list'] });
    },
  });
}
